<template>
  <div>
    <div class="searchDiv">
      <el-input class="searchInput" v-model="blurry" placeholder="请输入部门名称" clearable></el-input>
      <el-button type="primary" @click="getPositionsList">查询</el-button>
      <el-button v-if="hasPer('sys:positions:edit')" @click="editPositions" style="float: right;">新增</el-button>
    </div>
    <el-table :data="tableData" row-key="id" border height="calc(100vh - 180px)" max-height="calc(100vh - 180px)" default-expand-all>
      <el-table-column label="部门名称" prop="name"></el-table-column>
      <el-table-column label="类型" prop="name">
        <template slot-scope="scope">
          <el-tag type="success">{{$dict.nameOf('positions_type', scope.row.type)}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="负责人" prop="managerName"></el-table-column>
      <el-table-column label="描述" prop="description"></el-table-column>
      <el-table-column label="操作" prop="option" width="150px" align="center">
        <template slot-scope="scope">
          <el-button v-if="hasPer('sys:positions:edit') && scope.row.type !== '0' " type="primary"
                     @click="editPositions(JSON.parse(JSON.stringify(scope.row)))">编辑
          </el-button>
          <el-button v-if="hasPer('sys:positions:del')  && scope.row.type !== '0' " type="danger" @click="delPositions(scope.row.id, scope.row.name)">删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <edit-positions edit-menu :dialog-visible.sync="dialogVisible" :tree-data="tableData" :positions-obj="menuObj"
                    @get-list="getPositionsList"/>
  </div>
</template>

<script>
import {delPositions, getPositionsTree} from "@/api/sys/positions/sysPositions";
import {infoMsg, successMsg} from "@/utils/message";
import {hasPer} from "@/utils/common";
import editPositions from "./editPositions";

export default {
  name: "index",
  components: {
    editPositions
  },
  data() {
    return {
      blurry: '',
      dialogVisible: false,
      menuObj: {},
      tableData: []
    }
  },
  mounted() {
    this.getPositionsList()
  },
  methods: {
    hasPer,
    //  获取列表
    getPositionsList() {
      getPositionsTree({blurry: this.blurry}).then(res => {
        this.tableData = res
      })
    },
    //  编辑菜单
    editPositions(row) {
      this.dialogVisible = true
      this.menuObj = row.id ? row : {}
    },
    //  删除菜单
    delPositions(id, name) {
      this.$confirm('确定删除菜单【' + name + '】？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delPositions({id: id}).then(() => {
          successMsg("操作成功")
          this.getPositionsList()
        })
      }).catch(() => {
        infoMsg('操作已取消')
      })
    }
  }
}
</script>

<style scoped>

</style>